import { instantFromEpochMilliseconds, parseInstant } from "./validation.js";
function createClock(readEpochMilliseconds) {
  return Object.freeze({ now: () => instantFromEpochMilliseconds(readEpochMilliseconds()) });
}
function createFixedClock(now) {
  const instant = parseInstant(now);
  return Object.freeze({ now: () => instant });
}
const systemClock = createClock(() => Date.now());
export {
  createClock,
  createFixedClock,
  systemClock
};
//# sourceMappingURL=clock.js.map
